import React from 'react';
import DisplayCurrency from "../services/DisplayCurrency";

const Summary = ({item}) => {
  if (item.code) {
    return (
      <div>
        <h3>
          Summary
        </h3>
        <p><b>Plan Code:</b> {item.code}</p>
        <p><b>Item:</b> {item.name}</p>
        <p><b>Price:</b> {DisplayCurrency(item.currency)}{item.price}</p>
      </div>
    );
  }
  else {
    return (
      <div>
        <h3>
          Summary
        </h3>
      </div>
    );
  }
  
};

export default Summary;
